import { useEffect } from 'react';

import { VERSION } from '#src/config.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';
import { asObject } from '#src/lib/json.ts';

type User = { id: string; featureFlagCustomAttributes: Json };

/** Keeps the LaunchDarkly context in sync with the signed-in user. */
export const useIdentifyFeatureFlags = (
  currentUser: User | null | undefined
) => {
  const { platform } = useIsMobileApp();
  const { identify, identifyLoggedOut } = useFeatureFlags();
  const id = currentUser?.id;
  const customAttributes = currentUser?.featureFlagCustomAttributes;

  useEffect(() => {
    if (id) {
      identify?.({
        key: id,
        custom: {
          ...asObject(customAttributes ?? {}),
          webVersion: +VERSION,
          webviewPlatform: platform,
        },
      });
    } else {
      // No-op unless the visit started with a user who has since signed out.
      identifyLoggedOut?.();
    }
  }, [identify, identifyLoggedOut, id, customAttributes, platform]);
};
